export function addUniquenotEmptyElements(entities) {
    return [...new Set(entities)].filter(e => e !== undefined);
}
//# sourceMappingURL=addUniquenotEmptyElements.js.map